import * as React from "react";
import { observer } from "mobx-react";
import { useContext } from "react";
import { ContactViewStoreContext } from "../../context/store";
import { Input, Form, Checkbox } from "antd";
import { css } from "@emotion/core";
import { setInputMode } from "../../services/input";

export const EmailFormItem = observer(() => {
  const store = useContext(ContactViewStoreContext);

  return (
    <Form.Item label="ご本人様メールアドレス">
      <Input
        ref={setInputMode("email")}
        type="email"
        value={store.email}
        onChange={e => {
          store.email = e.target.value;
        }}
      />
      <Checkbox
        css={css`
          margin-top: 5px;
          line-height: 1.5;
          font-size: 12px !important;
        `}
        checked={store.preferSMS}
        onChange={e => {
          store.preferSMS = e.target.checked;
        }}
      >
        メールアドレスを持っていないため、電話番号によるショートメール(SMS)のみを希望する
      </Checkbox>
    </Form.Item>
  );
});
